import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Navigation } from './Navigation';
import { LoginForm } from '../auth/LoginForm';

export const AppLayout = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-pink-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading PFI Connect...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-pink-50 to-white flex items-center justify-center p-4">
        <LoginForm />
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-gradient-to-br from-pink-25 via-purple-25 to-orange-25 relative">
      {/* Background pattern overlay */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="flamingo-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
              <circle cx="50" cy="50" r="2" fill="#ec4899"/>
              <path d="M 40 50 Q 35 40 42 35" stroke="#ec4899" strokeWidth="1" fill="none"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#flamingo-pattern)" />
        </svg>
      </div>
      
      <Navigation />
      <main className="flex-1 ml-64 overflow-y-auto relative z-10">
        <div className="p-8 min-h-full">
          <div className="max-w-7xl mx-auto">
            {children}
          </div>
        </div>
      </main>
    </div>
  );
};